export default class FilterChiclets {
  constructor(container) {
    this.container = container;
    if (!this.container) return;

    this.container.addEventListener("click", (e) => {
      if (e.target.classList.contains("remove-chiclet")) {
        const chiclet = e.target.closest(".filter-chiclet");
        const slug = chiclet?.dataset.slug;
        if (slug && this.onRemove) {
          this.onRemove(slug);
        }
      }
    });
  }

  render(items, onRemove) {
    this.onRemove = onRemove;
    this.container.innerHTML = "";

    if (!items.length) return;

    const html = items
      .map(
        ({ slug, label }) => `
          <span class="filter-chiclet" data-slug="${slug}">
            ${label}
            <button class="remove-chiclet" type="button">&times;</button>
          </span>
        `
      )
      .join("");

    this.container.insertAdjacentHTML("beforeend", html);
  }
}
